import React, { useEffect, useState } from 'react';
import Link from 'next/link';

function RecruitHeader() {
    return (
    <div id="header">
        <div className="bg">
            <h1> 
                <Link href="https://recruit.sbs.co.kr:994/main/index">
                    <img src="https://dymstorage.saramin.co.kr/neodymfiles/download_security.php?file=php8baQVc&amp;path=/mgr/template/image/994" alt="로고" style={{height:'40px'}}/>
                </Link> 
            </h1>
            {/* <!-- gnb --> */}
            <div id="gnb">
                <h2>메인 네비게이션</h2>
                <ul id="gnbNavi">
                    <li className="first"><Link href="/"><a target="_blank">회사 소개</a></Link></li>
                    <li><Link href="/recruit/job/1">직무 안내</Link></li>
                    <li><Link href="https://recruit.sbs.co.kr:994/main/contents/3">채용 프로세스</Link></li>
                    <li><Link href="https://recruit.sbs.co.kr:994/apply_site/recruit/list">채용 공고</Link></li>
                    <li><Link href="https://recruit.sbs.co.kr:994/apply_site/apply/list">지원서 확인</Link></li>
                    <li><Link href="https://recruit.sbs.co.kr:994/apply_site/question/list">채용 문의</Link></li>
                </ul>
		    </div>
            {/* <!-- //gnb --> */}
        </div>
    </div>);
}

export default RecruitHeader;